import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const fields = {
  _id: '',
  taxYear: '',
  tifTaxDistrict: '',
  distributionTaxDistrict: '',
  baseValue: '',
  levy: '',
  targetAmount: '',
  collections: '',
  distributions: '',
  overgaeToTif: '',
  lock: '',
  description: '',
  city: '',
  pageBreakBefore: '',
};
const fields1 = {
  modifiedCount: '',
};

export const tifDistricts = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    selectedItems: [],
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
  },
  actions: {
    async loadTifDistrictsRecords({ commit, dispatch }, {
      criteria, baseCrudKey,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query tifDistricts($criteria: tifDistrictsCriteriaType) {
            tifDistricts(criteria: $criteria) {
              ${fieldsToGqlString(fields)},
            }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const tifDistrictsData = results.data.tifDistricts;
          commit('base/crud/setItems', [baseCrudKey, tifDistrictsData], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting List.', { root: true });
      }
    },
    async upserttifDistrict({ dispatch, rootGetters, commit }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upserttifDistrict($item: tifDistrictsInputType!)  {
            upserttifDistrict(upsert: $item) {
              ${fieldsToGqlString(fields)},
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const tifDistrcitData = rootGetters['base/crud/items'](baseCrudKey);
        const newTifDistrict = results.data.upserttifDistrict;
        const newList = mergeByIdNewAtTop(tifDistrcitData || [], newTifDistrict);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the List', { root: true });
      }
    },
    async reTotalTifRecord({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query reTotalTifCollections($criteria: tifDistrictsCriteriaType) {
                reTotalTifCollections(criteria: $criteria) {
              ${fieldsToGqlString(fields1)},
                  }
                }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const result = results.data ? (results.data.reTotalTifCollections) : {};
        dispatch('flashSuccess', 'record updated successfully', { root: true });
        return result;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while updating record.', { root: true });
      }
      return null;
    },
    async updateTifAfterApportionmentLocked({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query updateTifCollections($criteria: tifDistrictsCriteriaType) {
                updateTifCollections(criteria: $criteria) {
              ${fieldsToGqlString(fields1)},
                  }
                }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const result = results.data ? (results.data.updateTifCollections) : {};
        dispatch('flashSuccess', 'record updated successfully', { root: true });
        return result;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while updating record.', { root: true });
      }
      return null;
    },
  },
};

export default tifDistricts;
